import {
    UID, SESSION_ID, IS_AUTH, ERROR_STATE,
    MENUS, MY_PAGES, LOCALE, PARAMS, POPUP_PARAMS, REG_PARAMS,
    TOKEN, CORP_CD, ROLES, DEPT_NO, DEPT_LEVEL_CD,
    LOGIN_NO, LOGIN_RHQ, LOGIN_SYSTEM, SUPER_USER_YN,
    SUPPORT_SNB, SUPPORT_SNB_PARAMS, CONN_SYSTEM, RETURN_SYSTEM,
    LOGIN_ID, COUNTRY_CD, COUNTRY_NM, CORP_NO,
    CORP_NM, COMPANY_NO, JOIN_DATE, LAST_LOGIN,
    LANG_CD, GUID, EMAIL, LOGIN_COUNTRY_CD
} from './mutation_types';

import Vue      from 'vue';
import api      from '@/service';
import store    from '@/vuex/store';
import SDLUtil  from '@/utils/SDLUtil';

const setUID = ({ commit }, data) => {
    commit(UID, data);
};

const setSessionId = ({ commit }, data) => {
    commit(SESSION_ID, data);
};

const setErrorState = ({ commit }, data) => {
    commit(ERROR_STATE, data);
};

const setIsAuth = ({ commit }, data) => {
    commit(IS_AUTH, data);
};

const setMenus = ({ commit }, data) => {
    commit(MENUS, data);
};

const setMyPages = ({ commit }, data) => {
    commit(MY_PAGES, data);
};

const setLocale = ({ commit }, data) => {
    commit(LOCALE, data);
};

const setParams = ({ commit }, data) => {
    commit(PARAMS, data);
};

const setPopupParams = ({ commit }, data) => {
    commit(POPUP_PARAMS, data);
};

const setRegParams = ({ commit }, data) => {
    commit(REG_PARAMS, data);
};

const setToken = ({ commit }, data) => {
    commit(TOKEN, data);
};

const setCorpCd = ({ commit }, data) => {
    commit(CORP_CD, data);
};

const setRoles = ({ commit }, data) => {
    commit(ROLES, data);
};

const setDeptNo = ({ commit }, data) => {
    commit(DEPT_NO, data);
};

const setDeptLevelCd = ({ commit }, data) => {
    commit(DEPT_LEVEL_CD, data);
};

const setLoginNo = ({ commit }, data) => {
    commit(LOGIN_NO, data);
};

const setLoginRhq = ({ commit }, data) => {
    commit(LOGIN_RHQ, data);
};

const setLoginSystem = ({ commit }, data) => {
    commit(LOGIN_SYSTEM, data);
};

const setSuperUserYn = ({ commit }, data) => {
    commit(SUPER_USER_YN, data);
};

const setSupportSnb = ({ commit }, data) => {
    commit(SUPPORT_SNB, data);
};

const setSupportSnbParams = ({ commit }, data) => {
    commit(SUPPORT_SNB_PARAMS, data);
};

const setConnSystem = ({ commit }, data) => {
    commit(CONN_SYSTEM, data);
};

const setReturnSystem = ({ commit }, data) => {
    commit(RETURN_SYSTEM, data);
};

const setLoginId = ({ commit }, data) => {
    commit(LOGIN_ID, data);
};

const setCountryCd = ({ commit }, data) => {
    commit(COUNTRY_CD, data);
};

const setCountryNm = ({ commit }, data) => {
    commit(COUNTRY_NM, data);
};

const setCorpNo = ({ commit }, data) => {
    commit(CORP_NO, data);
};

const setCorpNm = ({ commit }, data) => {
    commit(CORP_NM, data);
};

const setCompanyNo = ({ commit }, data) => {
    commit(COMPANY_NO, data);
};

const setJoinDate = ({ commit }, data) => {
    commit(JOIN_DATE, data);
};

const setLastLogin = ({ commit }, data) => {
    commit(LAST_LOGIN, data);
};

const setLangCd = ({ commit }, data) => {
    commit(LANG_CD, data);
};

const setGuid = ({ commit }, data) => {
    commit(GUID, data);
};

const setEmail = ({ commit }, data) => {
    commit(EMAIL, data);
};

const setLoginCountryCd = ({ commit }, data) => {
    commit(LOGIN_COUNTRY_CD, data);
};

const processResponse = (store, loginResponse) => {
    /*switch (loginResponse.code) {
        case 'authOk':
            setUID(store, loginResponse.uid);
            setErrorState(store, { code: loginResponse.code });
            setIsAuth(store, true);
            break;
        case 'exception':
            setErrorState(store, { code: loginResponse.code, message: 'System error' });
            setIsAuth(store, false);
            break;
        default:
            // Vue.$log.debug(typeof loginResponse.code);
            if (typeof loginResponse.code === 'number') {
                loginResponse.code = String(loginResponse.code);
            }
            setErrorState(store, loginResponse);
            setIsAuth(store, false);
            break;
    }*/
    Vue.$log.info('VUEX Actions processResponse => ', loginResponse);
    switch (loginResponse.code) {
        case 'authOk':
            let menuList = loginResponse.menuList;
            if (menuList.length > 0) {
                setMenus(store, menuList);

                // myPage Setting
                let myPageListIdx = _.findIndex(menuList, function(menu) { return menu.menuId == 'TOP_1000000003'; });
                if(myPageListIdx > -1) {
                    setMyPages(store, menuList[myPageListIdx]);
                } else {
                    setMyPages(store, []);
                };

            } else {
                Vue.$log.error('※ loginResponse menuList.length == 0');
                SDLUtil.alert({
                    title: "Aleat",
                    // msg: "Menu is an empty! <br/>Re-login and change a subsidiary.",
                    msg: "Menu is not available. <br/>Please login again.",
                    okLabel: "Confirm",
                    onOkEvt: function(){
                        setIsAuth(store, false);
                        api.logout();
                    }
                });
                break;
            }

            setToken(store, loginResponse.userToken);
            setIsAuth(store, true);
            break;

        default:
            setErrorState(store, loginResponse);
            setIsAuth(store, false);
            break;
    }
};

export default {
    async directLogin(store, { loginId, loginPwd, loginSystem, loginType, loadMenuKind }) {
        /*
        const LOGIN_PWD = ' ';
        if(loginId === ' ' && loginPwd !== LOGIN_PWD) {
            SDLUtil.alert({
                title: 'WARNING',
                msg: 'Wrong password.',
                okLabel: 'Ok',
                onOkEvt: () => {
                    return false;
                }
            });

        } else {
            loginPwd = 'password';
            const loginResponse = await api.directLogin(loginId, loginPwd, loginSystem, loginType, loadMenuKind);
            processResponse(store, loginResponse);
            return store.getters.getIsAuth;
        };
        */

        const loginResponse = await api.directLogin(loginId, loginPwd, loginSystem, loginType, loadMenuKind);
        processResponse(store, loginResponse);
        return store.getters.getIsAuth;
    },
    async loginEpTray(store, { epTrayKey }) {
        const loginResponse = await api.loginEpTray(epTrayKey);
        processResponse(store, loginResponse);
        api.logout();
        return store.getters.getIsAuth;
    },
    async changeSubsidiary(store, { topRhqCd, topRhqNm, topSubsidiaryCd, topSubsidiaryNm, loginSystem }) {
        Vue.$log.info("※ VUEX Actions changeSubsidiary => ", topRhqCd, '(' + topRhqNm + ') / ', topSubsidiaryCd, '(' + topSubsidiaryNm + ') / ', loginSystem);
        const loginResponse = await api.changeSubsidiary(topRhqCd, topRhqNm, topSubsidiaryCd, topSubsidiaryNm, loginSystem);
        processResponse(store, loginResponse);
        return store.getters.getIsAuth;
    },
    async setLoginFromOtherSystem(store, response) {
        Vue.$log.info("※ VUEX Actions setLoginFromOtherSystem => ", response);
        const returnResponse = await api.setLoginFromOtherSystem(response);
        processResponse(store, returnResponse);
        return store.getters.getIsAuth;
    },
    async setLoginFromOtherSystemCSP(store, response) {
        Vue.$log.info("※ VUEX Actions setLoginFromOtherSystemCSP => ", response);
        const returnResponse = await api.setLoginFromOtherSystemCSP(response);
        processResponse(store, returnResponse);
        return store.getters.getIsAuth;
    },
    logout() {
        api.logout();

        let that = this;
        return new Promise(function(resolve) {
            setTimeout( function(){ resolve(); }, 100 );
        });
    },
    async getMenus(store, forceRemote = false) {
        const menuResponse = await api.getMenus(forceRemote);
        setMenus(store, menuResponse);
    },
    clearCache() {
        api.clearCache();
    },
    setLocale,
    setParams,
    setToken,
    setRoles,
    setDeptLevelCd,
    setLoginNo,
    setLoginRhq,
    setLoginSystem,
    setSuperUserYn,
    setSupportSnb,
    setSupportSnbParams,
    setConnSystem,
    setReturnSystem,
    setLoginId,
    setCountryCd,
    setCountryNm,
    setCorpNo,
    setCorpNm,
    setCompanyNo,
    setJoinDate,
    setLastLogin,
    setLangCd,
    setGuid,
    setEmail,
    setLoginCountryCd,
};



// WEBPACK FOOTER //
// ./src/vuex/actions.js